var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"printing-block-root"},[(_vm.title)?_c('div',{staticClass:"printing-block-title"},[_c('field',{attrs:{"label":_vm.title,"type":"h3"}})],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }